import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import type GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import { trace } from 'owa-trace';

export default function handleGetOrSearchFileProviderItemsResponse(
    response: GetAttachmentDataProviderItemsResponse,
    fileProviderId: string,
    fileProviderType?: AttachmentDataProviderType,
    isSearch: boolean = false
): AttachmentDataProviderItem[] {
    if (response.ResultCode !== AttachmentResultCode.Success) {
        trace.warn(
            'FilePicker: updateFileProviderItems got non success result code for response ' +
                response.ResultCode
        );
        throw response.ResultCode;
    }

    // VSO 117590: Add suport for .aspx files in ODB search
    if (isSearch && fileProviderType === AttachmentDataProviderType.OneDrivePro) {
        response.Items.filter(i => i.Name.indexOf('.aspx') === -1);
    }

    response.Items.forEach(i => (i.AttachmentProviderId = fileProviderId));
    return response.Items;
}
